import React from 'react';

import EditorialPageFullWidthImageWrapper, {
  FullWidthImageBlockProps,
} from '../../page-components/editorial-page-full-width/editorial-page-full-width-image-wrapper';
import EditorialPageFullWidthTextWrapper, {
  FullWidthTextBlockProps,
} from '../../page-components/editorial-page-full-width/editorial-page-full-width-text-wrapper';
import EditorialPageFullWidthWrapper from '../../page-components/editorial-page-full-width/editorial-page-full-width-wrapper';
import {
  IMeetingPlaceLinkToAnyPage,
  MeetingPlaceLinkToAnyPageFragment,
} from '@/lib/fragments/meetingPlaceLinkToAnyPage';

export interface FullWidthTextAndImageProps
  extends FullWidthTextBlockProps,
    FullWidthImageBlockProps {
  id?: string;
}

export interface LinkProps {
  cardLink?: IMeetingPlaceLinkToAnyPage;
  externalLink?: string;
}

const EditorialFullWidthTextAndImageBlock = ({
  landscapeImageWrapper,
  portraitImageWrapper,
  imageAlignment,
  body,
  cardLink,
  externalLink,
  topBlock,
  cardType,
  textItem,
}: FullWidthTextAndImageProps) => {
  const renderLayout =
    landscapeImageWrapper || portraitImageWrapper ? (
      //Renders a component with an Image & Text
      <EditorialPageFullWidthImageWrapper
        portraitImageWrapper={
          portraitImageWrapper && landscapeImageWrapper
            ? undefined
            : portraitImageWrapper && !landscapeImageWrapper
              ? portraitImageWrapper
              : undefined
        }
        landscapeImageWrapper={
          landscapeImageWrapper && portraitImageWrapper
            ? undefined
            : landscapeImageWrapper && !portraitImageWrapper
              ? landscapeImageWrapper
              : undefined
        }
        imageAlignment={imageAlignment}
        cardType={cardType}
        cardLink={cardLink}
        topBlock={topBlock}
        externalLink={externalLink}
      >
        <EditorialPageFullWidthWrapper
          isImage={portraitImageWrapper || landscapeImageWrapper ? true : false}
          cardType={cardType}
          topBlock={topBlock ? topBlock : null}
          body={body}
        >
          <EditorialPageFullWidthTextWrapper
            body={body}
            cardType={cardType}
            textItem={textItem}
            isImage={
              portraitImageWrapper || landscapeImageWrapper ? true : false
            }
          />
        </EditorialPageFullWidthWrapper>
      </EditorialPageFullWidthImageWrapper>
    ) : (
      //Renders a component with Text
      <EditorialPageFullWidthWrapper
        isImage={portraitImageWrapper || landscapeImageWrapper ? true : false}
        cardLink={cardLink}
        externalLink={externalLink}
        cardType={cardType}
        topBlock={topBlock ? topBlock : null}
      >
        <EditorialPageFullWidthTextWrapper
          body={body}
          cardType={cardType}
          textItem={textItem}
          isImage={portraitImageWrapper || landscapeImageWrapper ? true : false}
        />
      </EditorialPageFullWidthWrapper>
    );

  return <>{renderLayout}</>;
};

export default EditorialFullWidthTextAndImageBlock;
